import { ColorPicker } from '@components/ArtBoard/ColorLibrary/ColorPicker'
import { TinyPopover } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { useState } from 'react'

import { PICKER_OFFSET_Y } from '../constants'
import css from './styles.module.css'

type TagsProps = React.ComponentProps<typeof TinyPopover.Tags>

export interface ColorPickerState {
  area: HTMLDivElement | null
  onAddColor: (hexCode: string) => void
  onClose: () => void
  onPreview: (hexCode?: string) => void
  shown: boolean
}

interface Props extends TagsProps {
  colorHex: string
  picker: ColorPickerState
}

// The popover content: the tags and, after "+" in a color menu, the color
// picker under them. Inside the popover a click on the picker is not a click
// outside: the popover stays open and the page stays selected.
export const TagsContent: React.FC<Props> = ({ colorHex, picker, ...tags }) => {
  const [area, setArea] = useState<HTMLDivElement | null>(null)

  return (
    <div className={css.content} ref={setArea}>
      <TinyPopover.Tags {...tags} />
      {picker.shown && (
        <ColorPicker
          colorHex={colorHex}
          colorPikerAreaRef={area}
          offset={{ y: PICKER_OFFSET_Y }}
          onColorChange={picker.onPreview}
          onOutsideClick={picker.onClose}
          onSetColor={picker.onAddColor}
          position="bottom"
        />
      )}
    </div>
  )
}
